import { Currency } from "appworks/services/currency/currency";
import { PartnerConnectManager } from "partner-connect/partner-connect-manager";

export class PartnerConnectCurrency extends Currency {
    public configure() {
        // PC handles currency formatting so we don't need to configure anything
    }

    public format(value: number, trailingDecimals: boolean = true, forceCreditMode?: boolean): string {
        return PartnerConnectManager.formatCurrency(value);
    }
}
